export default {
  paymentList: [],

}
